
window.addEventListener("load", async function() {
  const path = window.location.pathname
  if (path.includes("whatsapp-redirect")) {
    const productName = localStorage.getItem('currentProductName') || "Catalogo de productos";
    const phoneNumber = "%2B573246387685"; // El número de teléfono ya codificado para URL
    const baseMessage = "Hola Aurora Baby Essentials. Deseo más información sobre: "; // Mensaje base con espacio al final
    // Combina el mensaje base con el nombre del producto
    const fullMessage = baseMessage + productName;
    const encodedMessage = encodeURIComponent(fullMessage);
    const whatsappUrl = `https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedMessage}&type=phone_number&app_absent=0`;
    window.location.href = whatsappUrl
  }
});